import React, { useEffect, useState, FC } from "react";
import { Button, message, Select, Input, Tooltip, Form, Image, Modal } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import useNavModel from "@/model/navModel";
import { repairFormatNum, formatNum, momentFormats, momentFormat } from "@/utils/utils"
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModels";
import { globalPrompt } from "@/components/message";
import { ITopType } from "@/types/ScmTypes";
import { DetailType, IServiceNatureCodeType, IPriceTypeEnum } from "@/types/ScmEnums";
import useGlobalModel, { getFindItem, transOptions, vehicleOption, getVehicleItem, getVinItem, vinOption } from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IVehicleFields } from "@/views/base/customerFiles/vehicle/vehicleType";
import { vehicleService } from "@/views/base/customerFiles/vehicle/vehicleService";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { debounce } from "lodash";
import { useMaintenanceModel } from "../../maintenanceModel";
import FontIcon from "@/components/YhIcon";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";
import { stockStatisticService } from "@/views/stock/statistic/stockStatisticService";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import TextPriviewImage from "../../TextPriviewImage";
import { invoiceModel } from "../../InvoiceModel";
import { YHDetailNav } from "@/components/YHDetailNav";
import { useWorkshopQueryModel } from "@/views/workshop/workshopQuery/workshopQueryModel";
import moment, { Moment } from "moment"
import { maintenanceService } from "../../maintenanceService";
import { getBaseImgLookUrl } from "@/utils/constants";
import { FinalInspectionModal } from "./FinalInspectionModal";
import { RobotFilled, RobotOutlined, SignatureOutlined } from "@ant-design/icons";
import AITroubleAnalysisModal from "@/components/chatAI/chat";

export const FormBox: FC<ITopType> = ({ id, mode, parentInfo, IFormRef }) => {
    const { imageUrl } = invoiceModel();
    const {
        setSelectedRowKeys,
        setDescRows,
        setSelectedRow
    } = useMaintenanceModel();
    const { getTreeNodeName } = useDictModel();
    const msgList: any = {
        'M-001': '车辆里程小于上一次维修里程!',
        'M-002': '车辆里程距离上维修里程超过八千公里，该车辆需要做一级保养以及二级保养!',
        'M-003': '车辆里程距离上保养里程超过八千公里，该车辆需要做一级保养以及二级保养!',
        'M-004': '车辆里程距离上保养里程超过三千五百公里，该车辆需要做一级保养!',
        'M-005': '车辆里程距离上次二级保养里程超过八千公里，该车辆需要做二级保养!',
        'M-006': '车辆里程距离上保养里程超过四千公里，该车辆需要做二级保养!',
    }
    const [kmData, setKmData] = useState<string>('')
    const {
        updateAddFormVal,
        updateEditFormVal,
        setVehicleEditAll,
        setVehicleAddAll,
        insertDetail,
        editDetail,
        resetAddCatch,
        formComputeRule,
        resetEditCatch,
        getDetailEditOne,
        setTopButsControl,
        setDetailMaterialAddList,
        setDetailItemAddList,
        setDetailItemEditList,
        setDetailMaterialEditList,
        setConsumeHistoryVisible,
        setConsumeHistoryModel,
        setRepairHistoryModel,
        setRepairHistoryVisible,
        setSaveLoading,
        setSettleVisible,
        setFinalVisible,
        onExamine,
        onBackApproved,
        onBackExamine,
        onApproved,
        vehicleEditAll,
        addDesc,
        editDesc,
        detailAddForm,
        detailEditForm,
        detailLookForm,
        vehicleAddAll,
        detailMaterialAddList,
        detailItemAddList,
        detailItemEditList,
        detailMaterialEditList,
        saveLoading,
        topButsControl,
        finalVisible,
    } = useMaintenanceDetailsModel();
    const { getTreeNodeOne } = useDictModel();
    const { finished } = useWorkshopQueryModel();
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { beShopDs, CustomerData, shopAndOrg: { shopId, shopCode, shopName, shopType }, allShopDs } = useGlobalModel();
    let { serviceNatureCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm
    const [vehicleVal, setVehicleVal] = useState<boolean>(false)
    // 控制签名弹窗显示/隐藏的状态
    const [signatureVisible, setSignatureVisible] = useState<boolean>(false);

    const typeForm: any = {
        add: { ...detailAddForm },
        edit: detailEditForm,
        look: detailLookForm
    }
    const formList: any = {
        add: detailMaterialAddList,
        edit: detailMaterialEditList,
    }
    useEffect(() => {
        setVehicleVal(false)
        setKmData('')
        if (mode === DetailType.add) {
            return
        }
        else {
            if (!Object.keys(detailEditForm).length || mode === DetailType.edit) {
                resetEditCatch(mode)
                getDetailEditOne(id, mode)
            }

        }
        mode === DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])

    // useEffect(() => {
    //     if (typeForm[mode].mileage && vehicleVal) {
    //         findVehicleDetial(typeForm[mode].licensePlate, typeForm[mode].mileage.toString())
    //     }
    // }, [typeForm[mode].licensePlate])
    useEffect(() => {
        if (typeForm[mode].licensePlate && (mode === DetailType.add || typeForm[mode].status == 'maintenance.create') && !typeForm[mode].msg1) {
            findVehicleCode(typeForm[mode].licensePlate)
        }
    }, [typeForm[mode].licensePlate])

    useEffect(() => {
        return () => {
            !findNav("4-1-1") && resetAddCatch(mode);
            !findNav("4-1-2") && resetEditCatch(mode);
        }
    }, [selectedNavId, shopCode])

    const { getSelectedDictOne } = useDictModel();
    const Options = [
        { label: "整单折扣", value: "1" },
        { label: "维修项目折扣", value: "2" },
        { label: "维修用料折扣", value: "3" }
    ]
    const [aiModalVisible, setAiModalVisible] = useState<boolean>(false);
    const onDiscount = () => {
        let discountNum: string = "1";
        let discountVal: string = "";

        globalPrompt("modal", {
            width: 380,
            title: "折扣",
            type: "info",
            text: <>
                <span>请选择折扣类型</span>
                <Select
                    showSearch={true}
                    defaultValue="1"
                    options={Options}
                    onChange={(value) => discountNum = value}
                />
                <span>请输入折扣系数</span>
                <Input
                    onChange={(e) => { discountVal = e.target.value }}
                    suffix="%"
                />
            </>,
            okText: "确定",
            onOk: () => {
                var re = /^[0-9]+.?[0-9]*$/;
                return new Promise((resolve, reject) => {
                    if (!re.test(discountVal)) {
                        reject("输入的值不是数字，请重新输入")
                        message.error("输入的值不是数字，请重新输入")

                    } else {
                        resolve(discountVal)
                    }
                }).then(res => {
                    if (discountNum === "1") {
                        onDiscountItem(+discountVal);
                        onDiscountMaterial(+discountVal);
                    } else if (discountNum === "2") {
                        onDiscountItem(+discountVal);
                    } else if (discountNum === "3") {
                        onDiscountMaterial(+discountVal);
                    }
                })
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }

    const onDiscountItem = (discount: number) => {
        let detailsItemList = mode === "add" ? detailItemAddList : detailItemEditList;
        let newDetailsItemList = detailsItemList.map((item) => {
            return {
                ...item,
                discountRate: discount,
                receivableAmount: +repairFormatNum(Number(item.itemAmount) * discount / 100),
            }
        })
        mode === "add" ? setDetailItemAddList(newDetailsItemList) : setDetailItemEditList(newDetailsItemList)
    }

    // 多图片预览组件，优化无图片时的显示
    const MultiImagePreview: React.FC<{ urls?: string[]; alts?: string[]; title?: string }> = ({ urls, alts, title = "图片" }) => {
        // 处理URL，确保是数组格式
        const imageUrls = Array.isArray(urls) ? urls : urls ? [urls] : [];
        const imageAlts = Array.isArray(alts) ? alts : alts ? [alts] : [];

        // 没有图片时显示提示
        if (imageUrls.length === 0) {
            return (
                <div style={{
                    width: '120px',
                    height: '30px',
                    border: '1px dashed #fe5a5a',
                    borderRadius: 4,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fe5a5a'
                }}>
                    暂无{title}
                </div>
            );
        }

        // 有图片时正常显示
        return (
            <div style={{ margin: '8px 0', display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                {imageUrls.map((url, index) => (
                    <div key={index} style={{ width: '140px' }}>
                        <Image
                            src={getBaseImgLookUrl(url)}
                            alt={imageAlts[index] || `${title}${index + 1}`}
                            style={{ width: '120px', height: '120px', objectFit: 'cover', borderRadius: 4, border: '1px solid #e8e8e8' }}
                        />
                    </div>
                ))}
            </div>
        );
    };

    const onDiscountMaterial = (discount: number) => {
        let detailsMaterialList = mode === "add" ? detailMaterialAddList : detailMaterialEditList;
        let newDetailsMaterialList = detailsMaterialList.map((item) => {
            return {
                ...item,
                discountRate: discount,
                receivableAmount: +repairFormatNum(Number(item.materialAmount) * discount / 100),
            }
        })
        mode === "add" ? setDetailMaterialAddList(newDetailsMaterialList) : setDetailMaterialEditList(newDetailsMaterialList)
    }

    const save = () => {
        if (!formComputeRule(mode)) return;
        let goodList = mode === "add" ? detailMaterialAddList : detailMaterialEditList;
        // 单价为0的数组
        let zeroList = goodList.filter(item => item.price == 0)
        let numAmount = 0;
        goodList.forEach((item) => {
            numAmount += item.decreaseAmount
        })
        // if (numAmount >= 1) {
        //     globalPrompt("message", { text: '单项优惠金额的总和不能大于1', type: "error" })
        //     return
        // }
        if (zeroList.length) {
            globalPrompt("message", { text: `【${zeroList.map(item => item.materialName).join()}】的价格不能为0`, type: "error" })
            return
        }
        IFormRef.current?.validateFields().then(async res => {
            if (res.settlementPartyCode === "settle-party.internal" && !!!res.note) {
                message.warning("结算方为部门内部费用时，备注为必填项，请补齐表单里的备注项");
                return false;
            }
            res.msg = res.msg1 && res.msg2 ? `${res.msg1}|${res.msg2}` : res.msg1 && !res.msg2 ? `${res.msg1}` : ""
            if (mode === "add") {
                let { receivableAll } = addDesc;
                receivableAll = +repairFormatNum(receivableAll);
                let { customerCode, customerName, payType, settlementPartyCode, bentityCode } = detailAddForm as { customerCode: string, payType: IVRMSettleTypeEnum, customerName: string, settlementPartyCode: string, bentityCode: string }

                if (!(customerCode && customerName && payType && settlementPartyCode)) {
                    message.warning("请补全客户名称或结算类型或结算方")
                    return false
                }
                await insertSave({ ...res })
            } else if (mode === "edit") {
                let { id, maintenanceCode } = detailEditForm
                const retData = await editDetail({ ...res, id, maintenanceCode })
                globalPrompt("message", { text: "编辑成功", type: "success" });
                if (retData) {
                    globalPrompt("message", { text: "编辑成功", type: "success" });
                    await getDetailEditOne(maintenanceCode as string, mode)
                }
            }
        })
    }

    const savsTips = (info: string, isSave: boolean, from: any = {}) => {
        globalPrompt("modal", {
            title: "维修单详情保存",
            type: "warning",
            text: info,
            okText: "确定",
            onOk: debounce(async () => {
                if (isSave) {
                    if (mode === "add") {
                        await insertSave(from)
                    } else if (mode === "edit") {
                        const retData = await editDetail(from)
                        if (retData) {
                            globalPrompt("message", { text: "编辑成功", type: "success" });
                            await getDetailEditOne(from.maintenanceCode as string, mode)
                        }
                    }
                }
            }, 500),
            cancelText: "取消",
            onCancel: () => { }
        })
    }

    const insertSave = async (res: any) => {
        let { receivableAll } = addDesc
        if (receivableAll < 0) {
            globalPrompt("modal", {
                title: "维修单详情保存",
                type: "warning",
                text: "当前单据为负数金额，是否确认？？",
                okText: "确定",
                onOk: debounce(async () => { await saveResult(res) }, 500),
                cancelText: "取消",
                onCancel: () => { }
            })
        } else {
            await saveResult(res)
        }
    }

    const saveResult = async (res: any) => {
        const retData = await insertDetail(res) as any
        if (retData) {
            globalPrompt("message", { text: "新增成功", type: "success" });
            setSelectedRowKeys([retData?.id as string])
            setDescRows([retData])
            setSelectedRow(retData)
            resetAddCatch(mode)
            goBack();
        }
    }

    const goBack = () => {
        if (parentInfo) {
            replaceNav(selectedNavId, parentInfo.selectedNavId);
        } else {
            replaceNav(selectedNavId, "4-1")
        }
    }

    const onRefresh = () => {
        if (mode === "add") {
            IFormRef.current?.resetFields()
            getVehicleAllList()
            resetAddCatch()
        } else if (mode === "edit") {
            getDetailEditOne(id, mode)
        }
        message.success("刷新成功")
    }

    const isMaterialModel = () => {
        if (mode === "look") return false
        if (mode === "edit" && (detailEditForm.status === DictCodeEnmu.MAINTENANCE_COMPLETED || detailEditForm.status === DictCodeEnmu.MAINTENANCE_STATUS_FINAL || detailEditForm.status === DictCodeEnmu.MAINTENANCE_SETTLE || detailEditForm.status === DictCodeEnmu.MAINTENANCE_UNDER_REVIEW || detailEditForm.status === "maintenance-status.paying")) {
            return false;
        }
        return true;
    }

    const onSettle = () => {
        if (detailEditForm.status === "maintenance-status.final" || detailEditForm.status === "maintenance-status.paying" || mode === "look") {
            setSettleVisible(true)
        } else {
            message.error("您的工单还没有完工，无法进行结算")
        }

    }

    const toFinal = () => {
        setFinalVisible(true)

    }

    const Examine = async () => {
        let auditReason: string = ""
        globalPrompt("modal", {
            title: "维修单审核",
            type: "success",
            text: <><span>请输入审核原因</span>
                <Input required onChange={(e) => { auditReason = e.target.value }} /></>,
            okText: "确定",
            onOk: async () => {
                if (auditReason == '') {
                    message.error("请输入审核原因!");
                    return Promise.reject();; // 阻止弹窗关闭
                } else {
                    let obj = {
                        id: detailEditForm.id,
                        maintenanceCode: detailEditForm.maintenanceCode,
                        auditReason
                    }
                    let retData = await onExamine(obj)
                    if (retData) {
                        message.success("审核成功");
                        getDetailEditOne(detailEditForm.maintenanceCode as string, mode);
                    }
                    return true; // 允许弹窗关闭
                }
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }

    const Approved = async () => {
        let auditMsg: string = ""
        globalPrompt("modal", {
            title: "维修单审核完成",
            type: "success",
            text: <>
                <div style={{ marginBottom: '8px' }}>
                    <span>完工申请原因：<span style={{ color: 'red' }}>{detailEditForm.auditReason}</span></span>
                </div>
                <div style={{ marginBottom: '8px' }}>
                    <span>请输入审核完成原因</span>
                </div>
                <div>
                    <Input onChange={(e) => { auditMsg = e.target.value }} />
                </div>
            </>,
            okText: "确定",
            onOk: async () => {
                let obj = {
                    id: detailEditForm.id,
                    maintenanceCode: detailEditForm.maintenanceCode,
                    auditMsg
                }
                let retData = await onApproved(obj)
                if (retData) {
                    message.success("审核成功");
                    getDetailEditOne(detailEditForm.maintenanceCode as string, mode);
                }
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }

    const Finished = () => {
        let newTime = momentFormats(detailEditForm.expectedCompletionTime);

        // 获取当前时间
        const currentTime = moment();
        const expectedTime = moment(newTime);

        // 判断是否超时
        const isTimeout = currentTime.isAfter(expectedTime);

        let timeoutCompleteReason = "";

        const createBaseModalConfig: any = (includeReasonInput = false) => {
            return {
                title: "工单完工",
                type: "success",
                text: includeReasonInput ? (
                    <>
                        <span>当前时间已超过预计完工时间，请输入超时完工原因</span>
                        <Input onChange={(e) => { timeoutCompleteReason = e.target.value }} />
                    </>
                ) : "",
                okText: "确定",
                onOk: () => {
                    if (includeReasonInput && !timeoutCompleteReason) {
                        message.error("请输入超时完工原因！");
                        return;
                    }

                    let obj: any = {
                        id: detailEditForm.id,
                        maintenanceCode: detailEditForm.maintenanceCode,
                    };

                    if (includeReasonInput) {
                        obj.timeoutCompleteReason = timeoutCompleteReason;
                    }

                    finished(obj).then(res => {
                        globalPrompt("message", { text: "订单完工", type: "success" });
                        getDetailEditOne(detailEditForm.maintenanceCode as string, mode);

                    });
                },
                cancelText: "取消",
                onCancel: () => { },
            };
        };
        // 根据是否超时显示不同的模态框
        if (isTimeout) {
            globalPrompt("modal", createBaseModalConfig(true));
        } else {
            globalPrompt("modal", createBaseModalConfig(false));
        }
    };

    //退单待审
    const backExamine = () => {
        let returnReason: string = ""
        globalPrompt("modal", {
            title: "维修退单审核",
            type: "success",
            text: <><span>请输入退单审核原因</span>
                <Input onChange={(e) => { returnReason = e.target.value }} /></>,
            okText: "确定",
            onOk: async () => {
                if (!returnReason) {
                    message.error("请输入退单审核原因！")
                } else {
                    let obj = {
                        id: detailEditForm.id,
                        maintenanceCode: detailEditForm.maintenanceCode,
                        returnReason
                    }
                    let retData = await onBackExamine(obj)
                    if (retData) {
                        message.success("审核成功");
                        getDetailEditOne(detailEditForm.maintenanceCode as string, mode);
                    }
                }
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }

    //退单审核通过
    const backApproved = () => {
        globalPrompt("modal", {
            title: "维修退单审核完成",
            type: "success",
            text: <><span>退单审核原因:{detailEditForm.returnReason}</span></>,
            okText: "确定",
            onOk: async () => {
                let obj = {
                    id: detailEditForm.id,
                    maintenanceCode: detailEditForm.maintenanceCode,
                }
                let retData = await onBackApproved(obj)
                if (retData) {
                    message.success("审核成功");
                    getDetailEditOne(detailEditForm.maintenanceCode as string, mode);
                }
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }

    const rightChildren = <>
        {mode === "edit" && <>
            <YhAuth resCode={ResourceAuthEnum.M_ED_CONFIRM_AUDIT}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={Examine}
                    disabled={topButsControl || !(detailEditForm.status === "maintenance.completed")}
                >完工申请</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_ED_CONFIRM_AUDIT_IN}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={Approved}
                    disabled={topButsControl || !(detailEditForm.status === "maintenance.under-review")}
                >完工申请通过</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_ED_CONFIRM_FINISH}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={Finished}
                    disabled={topButsControl || !(detailEditForm.status === "maintenance.approved")}
                >完工</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_ED_CONFIRM_BILL}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={onSettle}
                    disabled={topButsControl || !(detailEditForm.status === "maintenance-status.final" || detailEditForm.status === "maintenance-status.paying")}
                >确认结算</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_ED_CHANGEBACK_EXAMINE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={backExamine}
                    disabled={topButsControl || !!!(detailEditForm.status === "maintenance.settle" && detailEditForm.returnType === null)}
                >退单审核</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_ED_CHANGEBACK_APPROVED}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={backApproved}
                    disabled={topButsControl || !!!(detailEditForm.status === "maintenance.settle" && detailEditForm.returnType === "maintenance.chargeback.pend")}
                >退单审核通过</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_ED_CONFIRM_FINAL}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={toFinal}
                    disabled={topButsControl || detailEditForm.status !== "maintenance.completed"}
                >终检</Button>
            </YhAuth>
        </>}
        {mode === "look" &&
            <YhAuth resCode={ResourceAuthEnum.M_ED_CONFIRM_BILL}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={onSettle}
                >结算查看</Button>
            </YhAuth>
        }
        {isMaterialModel() && <>
            <YhAuth resCode={ResourceAuthEnum.M_ED_DISCOUNT_ALL}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={onDiscount}
                >快捷折扣</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_ED_SAVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={saveLoading}
                    onClick={debounce(() => { save() }, 900)}
                >{saveLoading ? '保存中' : '保存'}</Button>
            </YhAuth>
        </>}
        {mode !== "look" && <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onRefresh}
        >刷新</Button>}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>

    //车辆类型
    const vehicleTypeChange = (value: string, option: ISelectOption) => {
        toChooseList({ vehicleTypeCode: option.value })
        option && onChange({ vehicleTypeName: option.label, vehicleTypeCode: option.value });
    }

    //结算方
    const settlementPartyChange = (value: string, option: ISelectOption) => {
        option && onChange({ settlementPartyName: option.label, settlementPartyCode: option.value });
    }

    //结算类型
    const payTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ payTypeName: option.label, payType: option.value });
    }

    //发票类型
    const invoiceTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ invoiceTypeName: option.label, invoiceTypeCode: option.value });
    }

    //销售实体
    const bentityChange = (value: string, option: ISelectOption) => {
        option && onChange({ bentityName: option.label, bentityCode: option.value });
    }

    //服务性质
    const serviceNatureChange = (value: string, option: ISelectOption) => {
        if (value) {
            toChooseList({ serviceTypeCode: option.value })
            option && onChange({ serviceNatureName: option.label, serviceNatureCode: option.value })
            alterListPrice(typeForm[mode]?.priceTypeCode, value, customerCode as string);
        } else {
            onChange({ serviceNatureName: undefined, serviceNatureCode: undefined });
        }
    }


    //售价选择
    const priceTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ priceTypeName: option.label, priceTypeCode: option.value });
        if (value) {
            alterListPrice(value, serviceNatureCode as string, customerCode as string);
        }
    }

    const toChooseList = (value: any) => {
        let newData = {
            brandCode: typeForm[mode].brandCode,
            vehicleTypeCode: typeForm[mode].vehicleTypeCode,
            serviceTypeCode: typeForm[mode].serviceNatureCode,
            shopId: typeForm[mode].shopId,
            ...value
        }
        if (newData['brandCode'] && newData['vehicleTypeCode'] && newData['serviceTypeCode']) {
            maintenanceService.getChooseList(newData).then((res: any) => {
                if (res.retData) {
                    const { itemDetails, materialDetails, ...form } = res.retData;
                    if (itemDetails.length) {
                        let newList = itemDetails.map((item: any) => {
                            return {
                                ...item,
                                id: "",
                                detailsId: item.id,
                                discountRate: 100,
                                receivableAmount: item.itemAmount,
                            }
                        })
                        mode == 'add' ? setDetailItemAddList([...newList]) : setDetailItemEditList([...newList])
                    }
                    if (materialDetails.length) {
                        let newShelfRows: any[] = [];
                        let str: any = [];
                        materialDetails.forEach((item: any) => {
                            let num: number = item.num ?? 0;
                            let price: number = item.price
                            if (!item.success) {
                                str.push(item.msg)
                            }
                            if (item.repairStockVoList && item.repairStockVoList.length) {
                                const tempArr = item.repairStockVoList
                                for (let i = 0; i < tempArr.length; i++) {
                                    let goods = tempArr[i];
                                    // 公共字段
                                    let publicData = {
                                        id: "",
                                        key: goods.id,
                                        discountRate: 100,
                                        inventoryNum: goods.inventoryNum,
                                        materialCode: goods.materialCode,
                                        materialName: goods.materialName,
                                        num: goods.availableStock,
                                        price: item.salePrice,
                                        materialAmount: +formatNum((goods.availableStock as number) * (item.salePrice as number)),
                                        receivableAmount: +formatNum((goods.availableStock as number) * (item.salePrice as number) / 100),
                                        stockId: goods.id,
                                        detailsId: goods.id,
                                        purchaseId: goods.id,
                                        purchaseCode: goods.purchaseCode,
                                        warehouseCode: goods.warehouseCode,
                                        warehouseName: goods.warehouseName,
                                        shelfCode: goods.shelfCode,
                                        vehicleModel: goods.vehicleModel,
                                        model: goods.model,
                                        unitName: goods.unitName,
                                        unitCode: goods.unitCode,
                                        brandCode: goods.brandCode,
                                        brandName: goods.brandName,
                                        latestPurPrice: goods.price
                                    }
                                    // 可用库存 = 库存数量 - 占用库存
                                    let kynum = goods.inventoryNum - goods.inventoryOccupied;
                                    //当匹配到最后一个配件, 可用库存不满足用户填写数量, 那就设置该配件为异常配件, 数量设置为减完前面配件可用库存剩余的数量
                                    if (i === tempArr.length - 1 && kynum < num) {
                                        newShelfRows.push({
                                            ...publicData,
                                        })
                                        break
                                    }
                                    if (num <= 0) break;
                                    if (kynum) {
                                        num = num - kynum;
                                        // 当 可用数量 小于
                                        let tempNum = num < 0 ? kynum + num : kynum;
                                        newShelfRows.push({
                                            ...publicData,
                                            num: tempNum,
                                            materialAmount: +formatNum((goods.availableStock as number) * (tempNum as number)),
                                            receivableAmount: +formatNum((goods.availableStock as number) * (tempNum as number) / 100),
                                        })
                                    }
                                }
                            }
                        })
                        str.length !== 0 && globalPrompt('message', { text: `${str.join(',')}`, type: 'warning' })
                        mode == 'add' ? setDetailMaterialAddList([...newShelfRows]) : setDetailMaterialEditList([...newShelfRows])

                    }
                } else {
                    mode == 'add' ? setDetailItemAddList([]) : setDetailItemEditList([])
                    mode == 'add' ? setDetailMaterialAddList([]) : setDetailMaterialEditList([])
                }
            })
        }

    }

    //from销售类型，售价选择时更改 详情表格的价格信息
    const alterListPrice = async (priceTypeCode: string | undefined, serviceNatureCode: string, customerCode: string) => {
        let detailsList = mode == "add" ? detailMaterialAddList : detailMaterialEditList;
        if (!detailsList.length) return;
        if (!serviceNatureCode || !customerCode) {
            message.warning("请补全客户名称，维修类型才可以，对下列表格的价格数据进行更改");
            return false;
        }
        let newDetailsList = await Promise.all(detailsList.map(async (item) => {
            let { stockId, latestPurPrice, materialCode, lateSalePrice, discountRate, purchasePrice, decreaseAmount, retailPrice, num, ...params } = item as { latestPurPrice: number, decreaseAmount: number, lateSalePrice: number, purchasePrice: number, retailPrice: number, num: number, materialCode: string, discountRate: number, stockId: string }
            let newPrice: number = 0;
            if (!(serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN)) {
                switch (priceTypeCode) {
                    //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                    case IPriceTypeEnum.CUSTOMER_LATEST:
                        let { retData: { price: recentPrice } } = await purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string);
                        newPrice = +recentPrice;
                        break;
                    //售价选择 最近销价 
                    case IPriceTypeEnum.RECENT:
                        newPrice = await findPoDetailPrice(stockId, ["lateSalePrice", "retailPrice"], true)
                        break;
                    //售价选择 零售价
                    case IPriceTypeEnum.RETAIL:
                        let price1 = await findPoDetailPrice(stockId, ["retailPrice"])
                        let price2 = await findPoDetailPrice(stockId, ["price"])
                        newPrice = price1 > price2 ? price1 : price2;
                        break;
                    //售价选择 最新采购价
                    case IPriceTypeEnum.LATEST_PURCHASE:
                        let price3 = await findPoDetailPrice(stockId, ["latestPurPriceNew"])
                        let price4 = await findPoDetailPrice(stockId, ["price"])
                        newPrice = price3 > price4 ? price3 : price4;
                        break;
                    //售价选择 采购成本价
                    case IPriceTypeEnum.PUR_COST:
                        newPrice = await findPoDetailPrice(stockId, ["latestPurPrice", "purchasePrice"], true)
                        break;
                    //售价选择 档案进价
                    case IPriceTypeEnum.BUYING_PRICE:
                        newPrice = await findPoDetailPrice(stockId, ["purchasePrice"])
                        break;
                    //售价选择 石油价格
                    case IPriceTypeEnum.PETROLEUM:
                        newPrice = await findPoDetailPrice(stockId, ["petroleumPrice", "purchasePrice"], true);
                        break;
                }
            } else {
                newPrice = await findPoDetailPrice(stockId, ["latestPurPrice", "purchasePrice"], true)// latestPurPrice ?? purchasePrice
            }

            return {
                ...item,
                num: serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(num) : +formatNum(num),
                price: newPrice,
                latestPurPrice: item.price,
                materialAmount: serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(num * newPrice) : +formatNum(num * newPrice),
                receivableAmount: serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum((num * newPrice * discountRate) / 100 - decreaseAmount) : +formatNum((num * newPrice * discountRate) / 100 - decreaseAmount),
                discountedAmount: serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum((num * newPrice * discountRate) / 100) : +formatNum((num * newPrice * discountRate) / 100)
            }
        }))
        mode === "add" ? setDetailMaterialAddList(newDetailsList) : setDetailMaterialEditList(newDetailsList);
    }

    //根据销售类型，售价选择去查询采购明细对应的单价
    const findPoDetailPrice = async (stockId: string, priceType: string[], priceTypeLen?: boolean) => {
        let resultPrice: number = 0;
        await stockStatisticService.findId(stockId).then(async res => {
            let retData = await res.retData;
            resultPrice = priceTypeLen ? retData?.[priceType[0]] ?? retData?.[priceType[1]] : retData?.[priceType[0]];

        })
        return resultPrice
    }

    //服务地点
    const serviceLocationChange = (value: string, option: ISelectOption) => {
        option && onChange({ serviceLocationName: option.label, serviceLocationCode: option.value });
    }
    const orderTypeChange = (value: string, option: ISelectOption) => {
        // 先清空维修用料和项目列表，避免 alterListPrice 异步完成后用旧数据覆盖
        if (mode === "add") {
            setDetailItemAddList([]);
            setDetailMaterialAddList([]);
        } else {
            setDetailItemEditList([]);
            setDetailMaterialEditList([]);
        }
        if (value) {
            // 根据维修类型设置默认售价选择
            let priceTypeObj: any = {};
            if (value === 'maintenanceOrder-type.threeService') {
                priceTypeObj = { priceTypeCode: "sale-price-type.newPurchase", priceTypeName: '最新采购价' };
                // alterListPrice("sale-price-type.newPurchase", value, customerCode as string);
            } else {
                priceTypeObj = { priceTypeName: '零售价', priceTypeCode: "price-selection.retail" };
                // alterListPrice("price-selection.retail", value, customerCode as string);
            }
            option && onChange({ orderType: option.value, ...priceTypeObj })
        } else {
            onChange({ orderType: option.value, });
        }
    }
    //品牌
    const brandCodeChange = (value: string, option: ISelectOption) => {
        toChooseList({ brandCode: option.value })
        option && onChange({ brandName: option.label, brandCode: option.value });
    }

    //所属站点
    const shopNameChange = (value: string, option: ISelectOption) => {
        option && onChange({ shopId: option.value, shopCode: option.code, shopName: option.label });
    }

    useEffect(() => {
        let { customerCode } = mode === "add" ? detailAddForm : detailEditForm as { customerCode: string }
        getVehicleAllList({ customerCode })
    }, [mode])

    const disabledDate = (current: Moment) => {
        return current && current < moment(detailAddForm.enterTime)
    }

    const getVehicleAllList = async (param?: IVehicleFields) => {
        let params = {
            ...param,
            shopId,
            pageSize: -1,
            pageNum: 1
        }
        const { retData } = await vehicleService.pages(params)
        const { records } = retData
        if (records.length === 0) { globalPrompt("message", { text: "该客户下没有车辆，点击左侧车辆牌照去新增吧!", type: "warning" }) }
        let newRecords: any = records.map(item => {
            return {
                ...item,
                key: item.id,
                label: item.licensePlate,
                value: item.id,
                brandName: item.brandName,
                brandCode: item.brandCode,
            }
        })
        mode === "add" ? setVehicleAddAll(newRecords) : setVehicleEditAll(newRecords)

    }

    //客户名称
    const customerChange = (value: string, option: ISelectOption) => {
        if (value && option) {
            let { contact, phone, address, categoryCode, categoryName, brandCode, brandName, ...form } = getFindItem(value, CustomerData)
            option && onChange({
                customerName: option.label,
                customerCode: option.value,
                contact,
                phone,
                brandCode,
                brandName,
                customerAddress: address,
                customerTypeCode: categoryCode,
                customerTypeName: categoryName,
                licensePlate: null,
                vehicleTypeCode: null,
                vehicleTypeName: null,
                vehicleModel: null,
                vin: null
            });
            toChooseList({ vehicleTypeCode: null, brandCode: brandCode })
        }

        getVehicleAllList({ customerCode: option?.value as string })
    }

    //车辆牌照
    const vehicleChange = async (value: string, option: ISelectOption) => {
        let VehicleIList: any = mode === "add" ? vehicleAddAll : vehicleEditAll
        if (value && option) {
            let neData: any = {}
            setVehicleVal(true)
            let data = getVehicleItem(option.label, VehicleIList)
            let { customerName, customerCode, licensePlate, brandCode, brandName, categoryCode, categoryName, phone, contact, address, vin, typeCode, typeName, model, tonnage, vehicleNumber } = data
            option && onChange({
                ...neData,
                customerName,
                customerCode,
                contact,
                phone,
                customerAddress: address,
                vin,
                licensePlate,
                vehicleTypeCode: categoryCode,
                vehicleTypeName: categoryName,
                vehicleModel: model,
                customerTypeCode: typeCode,
                customerTypeName: typeName,
                brandCode,
                brandName,
                tonnage,
                vehicleNumber,
            });
            toChooseList({ vehicleTypeCode: categoryCode, brandCode })
        }
    }
    const findVehicleCode = async (VehicleCode: string) => {
        let params = {
            licensePlate: VehicleCode,
            shopId,
            pageSize: 2000,
            pageNum: 1
        }
        let { retData } = await vehicleService.pages(params)
        const { records } = retData
        if (records.length > 0) {
            let newData: any = records[0]
            const formattedTime = momentFormat(newData.nextMaintenanceTime);
            const currentTime = moment();
            const expectedTime = moment(formattedTime);
            const isOverdue = currentTime.isAfter(expectedTime);
            if (isOverdue) {
                globalPrompt("modal", {
                    title: "保养时间提醒",
                    type: "warning",
                    text: `已超出保养时间(${formattedTime}),请尽快处理!`,
                    okText: "确定",
                    onOk: () => {
                        onChange({ msg1: "保养时间已过，请尽快处理!" });
                    },
                    cancelText: "取消",
                    onCancel: () => {
                        onChange({ msg1: "保养时间已过，请尽快处理!" });
                    }
                });
            } else {
            }
        }
    }
    const findVehicleDetial = async (licensePlate: string, mileage: string) => {
        let newParams = {
            licensePlate,
            mileage,
            createTime: mode === "edit" ? typeForm[mode].createTime : ""
        }
        let { retData } = await maintenanceService.findVehicleDetial(newParams)
        if (retData) {
            if (msgList[retData.code] !== typeForm[mode].msg1) {
                if (retData.code == "M-001") {
                    let auditReason: string = ""
                    globalPrompt("modal", {
                        title: "提交里程原因:",
                        type: "success",
                        text: <><span style={{ color: 'red', lineHeight: '35px' }}>{retData.msg}</span>
                            <Input onChange={(e) => { auditReason = e.target.value }} /></>,
                        okText: "确定",
                        onOk: async () => {
                            onChange({ msg1: msgList[retData.code], msg2: auditReason })
                            message.success("提交成功");
                        },
                        cancelText: "取消",
                        onCancel: () => {
                        }
                    })
                } else {
                    message.warning(retData.msg);
                    onChange({ msg1: msgList[retData.code], msg2: undefined })
                }
            }
        }
        else {
            onChange({ msg1: undefined, msg2: undefined })
        }
    }

    const onBlur = async (e: any) => {
        let data: number = Number(e.target.value) ?? 0
        data = isNaN(data) ? 0 : data;
        if (kmData !== data.toString()) {
            setKmData(data.toString())
            if (data && typeForm[mode].licensePlate) {
                await findVehicleDetial(typeForm[mode].licensePlate, data.toString())
            }
        }
    }

    //vin码
    const vinChange = (value: string, option: ISelectOption) => {
        let VehicleIList: any = mode === "add" ? vehicleAddAll : vehicleEditAll
        if (value && option) {

            let { customerName, customerCode, licensePlate, brandCode, brandName, categoryCode, categoryName, phone, contact, address, vin, typeCode, typeName, model } = getVinItem(value, VehicleIList)
            option && onChange({
                customerName,
                customerCode,
                contact,
                phone,
                customerAddress: address,
                vin,
                licensePlate,
                vehicleTypeCode: categoryCode,
                vehicleTypeName: categoryName,
                vehicleModel: model,
                customerTypeCode: typeCode,
                customerTypeName: typeName,
                brandCode,
                brandName,
            });
        }
    }

    const goCustomer = () => {
        replaceNav(
            selectedNavId,
            "13-5-1-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id
                }
            },
            true)
    }

    const goVehicle = () => {
        replaceNav(
            selectedNavId,
            "13-5-2-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id,
                    customerCode: typeForm[mode].customerCode
                }
            },
            true)
    }

    const onConsumption = () => {
        let { customerCode, customerName } = typeForm[mode]
        if (!customerCode) {
            return message.warning("请先选择客户")
        }
        setConsumeHistoryVisible(true)
        setConsumeHistoryModel({ customerName: customerName as string })
    }

    const onRepairHistory = () => {
        let { licensePlate } = typeForm[mode]
        if (!licensePlate) {
            return message.warning("请先选择车辆")
        }
        setRepairHistoryVisible(true)
        setRepairHistoryModel({ licensePlate: licensePlate })
    }

    const title = <>
        <span>基础信息</span>
        <Tooltip placement="topLeft" title="消费记录">
            <FontIcon type="icon-xiaofeijilu" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={onConsumption}
            />
        </Tooltip>
        <Tooltip placement="topLeft" title="维修历史">
            <FontIcon type="icon-ic_history" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={onRepairHistory}
            />
        </Tooltip>
        <a className="color-blue" style={{ float: 'right', fontSize: '17px' }} onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>
    </>

    const baseFormItem: IYhFormItemsBox = {
        title: title,
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span className="click-span" onClick={goCustomer}>客户名称</span>,
                fieldName: "customerCode",
                options: transOptions(CustomerData),
                onSelectChange: customerChange,
                allowClear: true,
                showSearch: true,
                rules: [{ required: true, message: "请选择客户" }],
                hidden: mode === "look"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: mode !== "look"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "维修附加项",
                fieldName: "additionalItems",
                disable: true,
                hidden: true,
                span: 8,
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "维修类型",
                fieldName: "serviceNatureCode",
                options: getSelectedDictOne(DictCodeEnmu.REPAIR_TYPE),
                onSelectChange: serviceNatureChange,
                rules: [{ required: true, message: "维修类型" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span className="click-span" onClick={goVehicle}>车辆牌照</span>,
                fieldName: "licensePlate",
                allowClear: true,
                showSearch: true,
                options: mode === "add" ? vehicleOption(vehicleAddAll) : vehicleOption(vehicleEditAll),
                onSelectChange: vehicleChange,
                rules: [{ required: true, message: "请输入车牌号" }],
                waring: typeForm[mode].msg1
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "shopName",
                fieldName: "shopName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆里程",
                fieldName: "mileage",
                // onInputBlur: onBlur,
                suffix: <span style={{ color: "#6C72F3" }}>KM</span>,
                rules: [{ required: true, message: "请输入车辆里程" }],
                // waring: typeForm[mode].msg1
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: <span>故障描述 <RobotFilled
                    style={{
                        color: '#6C72F3',
                        cursor: 'pointer',
                        fontSize: '16px',
                        marginLeft: '3px'
                    }}
                    onClick={() => {
                        // if (typeForm[mode].faultDesc) {
                        setAiModalVisible(true);
                        // } else {
                        //     message.warning('请先输入故障描述');
                        // }
                    }}
                /></span>,
                fieldName: "faultDesc",
                detialVal: typeForm[mode].faultDesc
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "工单类型",
                fieldName: "orderType",
                disable: formList[mode]?.find((item: any) => item.status == "details.preparation.ware.out"),
                onSelectChange: orderTypeChange,
                options: getSelectedDictOne(DictCodeEnmu.MAINTENANCEORDER_TYPE),
                rules: [{ required: true, message: "请选择服务地点" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "整单优惠",
                fieldName: "favorableAmount",
                rules: [{ type: 'number', transform: (value) => Math.abs(Number(value)), message: `当前不是一个有效数字`, }],
                hidden: more,
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "服务地点",
                fieldName: "serviceLocationCode",
                onSelectChange: serviceLocationChange,
                options: getSelectedDictOne(DictCodeEnmu.SERVICE_ADDRESS),
                rules: [{ required: true, message: "请选择服务地点" }],
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "预约进厂时间",
                showTime: true,
                fieldName: "enterTime",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "车辆品牌",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.VEHICLE_BRAND),
                fieldName: "brandCode",
                onSelectChange: brandCodeChange,
                rules: [{ required: true, message: "请输入车辆品牌" }]
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "车辆类型",
                fieldName: "vehicleTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE),
                onSelectChange: vehicleTypeChange,
                rules: [{ required: true, message: "请输入车辆类型" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "所属站点",
                fieldName: "shopId",
                options: allShopDs,
                showSearch: false,
                onSelectChange: shopNameChange,
                rules: [{ required: true, message: "请选择所属站点" }],
                disable: shopType === 0 && mode == 'add' ? false : true,
                hidden: more,
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "VIN码",
                fieldName: "vin",
                allowClear: true,
                showSearch: true,
                onSelectChange: vinChange,
                options: mode === "add" ? vinOption(vehicleAddAll) : vinOption(vehicleEditAll),
                hidden: more,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "吨位",
                fieldName: "tonnage",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆编号",
                fieldName: "vehicleNumber",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "外修原因",
                fieldName: "outsideReason",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆型号",
                fieldName: "vehicleModel",
                hidden: more
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售实体",
                fieldName: "bentityCode",
                options: beShopDs,
                allowClear: true,
                showSearch: true,
                onSelectChange: bentityChange,
                hidden: more,
                disable: true,
                rules: [{ required: true, message: "请选择销售实体" }]
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "结算方",
                fieldName: "settlementPartyCode",
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_PARTY),
                onSelectChange: settlementPartyChange,
                hidden: more || mode === "look",
                rules: [{ required: true, message: "请选择结算方" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方",
                fieldName: "settlementPartyName",
                hidden: more || mode !== "look"
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "结算类型",
                fieldName: "payType",
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE),
                onSelectChange: payTypeChange,
                hidden: more || mode === "look",
                rules: [{ required: true, message: "请选择结算类型" }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算类型",
                fieldName: "payTypeName",
                hidden: more || mode !== "look"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "工作小时",
                fieldName: "workingHours",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "处理意见",
                fieldName: "faultResult",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户地址",
                fieldName: "customerAddress",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "待修内容",
                fieldName: "toBeRepaired",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "下次保养时间",
                fieldName: "nextMaintainTime",
                hidden: more
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "预约出厂时间",
                showTime: true,
                fieldName: "deliveryTime",
                disabledDate: disabledDate,
                hidden: more
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "售价选择",
                fieldName: "priceTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.PRICE_SELECTION),
                disable: true,
                hidden: more,
                onSelectChange: priceTypeChange,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                hidden: more
            },
            ...(typeForm[mode].invoiceNum ? [{
                type: FormItemTypeEnum.Button,
                fieldLabel: <a style={{ color: 'black' }}>发票号码：</a>,
                fieldName: "none",
                hidden: more,
                span: 2,
                labelCol: { offset: 10 },
            },
            {
                type: FormItemTypeEnum.Button,
                fieldLabel: typeForm[mode].invoiceNum ? <TextPriviewImage text={typeForm[mode].invoiceNum as string} previewList={typeForm[mode].invoiceMd5?.split(",")} imageUrl={imageUrl} /> : '自动带出',
                fieldName: "invoiceNum",
                span: 4,
                hidden: more,
                labelCol: { offset: 1 },
            }] : [
                {
                    type: FormItemTypeEnum.Input,
                    fieldLabel: "发票号码",
                    fieldName: "invoiceNum",
                    disable: true,
                    hidden: more,
                    placeholder: "自动带出",
                }
            ]),
            {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "发票类型",
                fieldName: "invoiceTypeCode",
                hidden: more,
                options: getSelectedDictOne(DictCodeEnmu.INVOICE_TYPE),
                onSelectChange: invoiceTypeChange,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开票人",
                fieldName: "invoiceOperator",
                hidden: more,
                disable: true,
                placeholder: "自动带出",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票上传时间",
                fieldName: "invoiceUploadTime",
                hidden: more,
                disable: true,
                placeholder: "自动带出",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务备注",
                fieldName: "fmsNote",
                hidden: more
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "完工申请原因",
                fieldName: "auditReason",
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "退单申请原因",
                fieldName: "returnReason",
                hidden: more,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "里程原因",
                fieldName: "msg2",
                disable: true,
                hidden: more,
                detialVal: typeForm[mode].msg2
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "里程原因",
                fieldName: "msg1",
                disable: true,
                hidden: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "送修人",
                fieldName: "contact",
                rules: [{ required: true, message: "请输入送修人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "送车电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入送车电话" }]
            },
            // {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: "是否转新天工",
            //     fieldName: "isXtg",
            //     options: [{ label: "是", value: 1 }],
            //     allowClear: true,
            //     hidden: more,
            // },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "销售实体名称",
                fieldName: "bentityName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆类型Name",
                fieldName: "vehicleTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "维修类型Name",
                fieldName: "maintenanceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方Name",
                fieldName: "settlementPartyName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方式Name",
                fieldName: "paymentMethodName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户类型Name",
                fieldName: "customerTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型Name",
                fieldName: "invoiceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "服务类型Name",
                fieldName: "serviceNatureName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "服务地点Name",
                fieldName: "serviceLocationName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "售价选择Name",
                fieldName: "priceTypeName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "brandName",
                fieldName: "brandName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "brandCode",
                fieldName: "brandCode",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: <span>终检人
                    <SignatureOutlined
                        style={{ fontSize: '20px', color: '#00BE87', cursor: 'pointer', marginLeft: '4px' }}
                        onClick={() => setSignatureVisible(true)}
                        title="查看签名"
                    />
                </span>,
                fieldName: "finalUser",
                hidden: !(typeForm[mode].status == 'maintenance-status.final' || typeForm[mode].status == 'maintenance.settle'),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "终检时间",
                fieldName: "finalTime",
                hidden: !(typeForm[mode].status == 'maintenance-status.final' || typeForm[mode].status == 'maintenance.settle'),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "终检意见",
                fieldName: "finalOpinion",
                hidden: !(typeForm[mode].status == 'maintenance-status.final' || typeForm[mode].status == 'maintenance.settle'),
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: "终检照片",
                fieldName: "finalMsg",
                span: 12,
                hidden: !(typeForm[mode].status == 'maintenance-status.final' || typeForm[mode].status == 'maintenance.settle'),
                formItem: (
                    <Form.Item
                        name="finalPhotos"
                        label="终检照片"
                        labelCol={{ span: 6 }}
                    >
                        <MultiImagePreview
                            urls={typeForm[mode].finalMsg}
                            alts={typeForm[mode].finalMsg}
                            title="终检照片"
                        />
                    </Form.Item>
                )
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: "故障照片",
                fieldName: "fileMsg",
                span: 24,
                formItem: (
                    <Form.Item
                        name="faultPhotos"
                        label="故障图片"
                        labelCol={{ span: 6 }}
                    >
                        <MultiImagePreview
                            urls={typeForm[mode].fileMsg}
                            alts={typeForm[mode].fileMsg}
                            title="故障图片"
                        />
                    </Form.Item>
                )
            },
        ]
    };

    const onChange = (changedValues: { [key: string]: any }) => {
        mode === "add" ? updateAddFormVal(changedValues) : updateEditFormVal(changedValues)
        setTopButsControl(true)
    }

    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        disabled: !isMaterialModel(),
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        维修单:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{typeForm[mode].maintenanceCode ?? "暂无"}</span>
                        状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#028e19' }}>{(typeForm[mode]?.status && getTreeNodeName(typeForm[mode]?.status as string)) ?? "暂无"}</span>
                        退单状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#028e19' }}>{(typeForm[mode]?.returnType && getTreeNodeName(typeForm[mode]?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                leftBtns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />

            {/* 终检签名弹窗 */}
            <Modal
                title="终检签名"
                open={signatureVisible}
                onCancel={() => setSignatureVisible(false)}
                footer={null}
                width={600}
                centered
            >
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                    {typeForm[mode].finalSignature ? (
                        <Image
                            src={getBaseImgLookUrl(typeForm[mode].finalSignature)}
                            alt="终检签名"
                            style={{ maxWidth: '100%', maxHeight: '400px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)' }}
                        />
                    ) : (
                        <div style={{
                            color: '#999',
                            fontSize: '16px',
                            padding: '40px 0',
                            border: '1px dashed #e8e8e8',
                            borderRadius: 4,
                            width: '100%',
                            textAlign: 'center'
                        }}>
                            暂无签名照片
                        </div>
                    )}
                </div>
            </Modal>
            <AITroubleAnalysisModal
                visible={aiModalVisible}
                onCancel={() => setAiModalVisible(false)}
                dataVal={typeForm[mode]}
            />
            <FinalInspectionModal
                visible={finalVisible}
                billId={typeForm[mode].id}
                billCode={typeForm[mode].maintenanceCode}
                onCancel={() => {
                    setFinalVisible(false)
                    getDetailEditOne(typeForm[mode].maintenanceCode, mode)
                }}
            />
        </>
    )
}
